import React from 'react'
import { Grid } from '@material-ui/core'

const FormRoot = ({ children }) => {
  return (
    <Grid container spacing={4}>
      {children}
    </Grid>
  )
}

export default FormRoot
